// Web ve native modülü bulunmayan eski binary için güvenli ses-yolu sözleşmesi.
// Tarayıcı çıkış aygıtını genellikle işletim sistemine bırakır; çalışmayan bir
// düğme göstermek yerine yeteneği kapalı bildiririz (9.4.11.2 / 9.4.11.3).
import type { AudioRoute, AudioRouteResult, AudioRouteState } from './audioRoute.types';

export type { AudioRoute, AudioRouteResult, AudioRouteState } from './audioRoute.types';

export const audioRoutingAvailable = false;
export async function startCallAudioSession(): Promise<AudioRouteState | null> { return null; }
export async function selectCallAudioRoute(_route: AudioRoute): Promise<AudioRouteResult> {
  return { ok: false, reason: 'unavailable' };
}
export async function stopCallAudioSession(): Promise<void> {}
export function observeCallAudioRoutes(_listener: (state: AudioRouteState) => void): () => void {
  return () => {};
}
